module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pgInner announcement"
  }, [_c('div', {
    staticClass: "headBar"
  }, [(_vm.type == 1) ? _c('span', [_vm._v("新建文章解读")]) : _vm._e(), _vm._v(" "), (_vm.type == 2) ? _c('span', [_vm._v("新建信息图解读")]) : _vm._e(), _vm._v(" "), (_vm.type == 3) ? _c('span', [_vm._v("新建视频解读")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "pgbody",
    style: ('height:' + _vm.pageH + 'px;')
  }, [_c('el-scrollbar', {
    ref: "scroller",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules,
      "inline-message": "true",
      "show-message": false
    }
  }, [_c('div', {
    staticClass: "tabContent"
  }, [_c('div', {
    staticClass: "text-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_vm._v("关联政策")]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "title"
    }
  }, [_c('el-select', {
    staticClass: "inpText",
    attrs: {
      "filterable": "",
      "remote": "",
      "placeholder": "请输入关键词",
      "size": "medium",
      "remote-method": _vm.goSeek,
      "loading": _vm.loading
    },
    model: {
      value: (_vm.params.cqjSbzcDeclarationPolicyId),
      callback: function($$v) {
        _vm.$set(_vm.params, "cqjSbzcDeclarationPolicyId", $$v)
      },
      expression: "params.cqjSbzcDeclarationPolicyId"
    }
  }, _vm._l((_vm.pocList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.title,
        "value": item.id
      }
    })
  }))], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_vm._v("解读标题")]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "title"
    }
  }, [_c('el-input', {
    staticClass: "inpText",
    attrs: {
      "size": "medium",
      "placeholder": "请输入标题"
    },
    model: {
      value: (_vm.params.title),
      callback: function($$v) {
        _vm.$set(_vm.params, "title", $$v)
      },
      expression: "params.title"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_vm._v("来源")]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "publishingDepartmentNames"
    }
  }, [_c('el-input', {
    staticClass: "inpText",
    attrs: {
      "size": "medium",
      "placeholder": "请输入发文机构"
    },
    model: {
      value: (_vm.params.publishingDepartmentNames),
      callback: function($$v) {
        _vm.$set(_vm.params, "publishingDepartmentNames", $$v)
      },
      expression: "params.publishingDepartmentNames"
    }
  })], 1)], 1)]), _vm._v(" "), (_vm.params.type == 1) ? _c('div', {
    staticClass: "text-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_vm._v("概要")]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "description"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "420px"
    },
    attrs: {
      "rows": "5",
      "type": "textarea",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.params.description),
      callback: function($$v) {
        _vm.$set(_vm.params, "description", $$v)
      },
      expression: "params.description"
    }
  })], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.params.type == 1) ? _c('div', {
    staticClass: "text-block scene-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_vm._v("内容")]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('textEditor', {
    ref: "textEditor",
    attrs: {
      "inContent": _vm.params.content
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.params.type == 2) ? _c('div', {
    staticClass: "text-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_vm._v("信息图")]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('imgs-upload', {
    attrs: {
      "files": _vm.params.videoContentId
    },
    on: {
      "fileChange": _vm.fileChange
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.params.type == 3) ? _c('div', {
    staticClass: "text-block mv-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_vm._v("视频")]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('mv-upload', {
    attrs: {
      "files": _vm.params.videoContentId
    },
    on: {
      "fileChange": _vm.fileChange
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_vm._v("封面图")]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('img-upload', {
    attrs: {
      "image": _vm.params.image,
      "tips": "（345*140推荐）"
    },
    on: {
      "imgChange": _vm.imgChange
    }
  })], 1)])])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pagefoot"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.directSave(1)
      }
    }
  }, [_vm._v("立即发布")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "plain": "",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.directSave(2)
      }
    }
  }, [_vm._v("存为草稿")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "plain": "",
      "size": "small"
    },
    on: {
      "click": _vm.goReturn
    }
  }, [_vm._v("取消")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-e5cb866c"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/Enterprise/unscramble/unsEdit.vue
// module id = 1578
// module chunks = 1